import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Pro4SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="m15.532 2.531.72-.206-.411-1.442-.721.206-14 4-.722.206.413 1.442.72-.206 14-4ZM7.437 6.207l.889-1.397.889 1.397 5.156 8.103.955 1.5H1.326l.954-1.5 5.157-8.103ZM4.058 14.31l4.268-6.706 4.267 6.706H4.058Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Pro4SVG;
